"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MINIMUM_THRESHOLD = 30;

exports.randomizeTimeout = function (ms) {
  return Array.isArray(ms) ? // random value inside the specified min and max thresholds
  ms[0] + Math.random() * (ms[1] - ms[0]) : // randomize the value - with a minimum threshold
  Math.max(Math.random() * ms, exports.MINIMUM_THRESHOLD);
};